import { CheckIcon, XIcon } from "lucide-react";
import React from "react";

interface IProps {
	children: React.ReactNode;
	isValid: boolean;
}

export default function PasswordRule({ isValid, children }: IProps) {
	return (
		<div className={`flex gap-2 items-center ${isValid ? "text-accent-foreground" : ""}`}>
			{isValid ? <CheckIcon className="size-4 text-green-600" /> : <XIcon className="size-4" />}
			<div>{children}</div>
		</div>
	)
}
